import { useEffect } from "react";

import { pushUserPropertiesToDataLayer } from "seneca-common/features/analytics/gtm";

import { Data } from "../../common";

export type userPropertiesScopeKeys = "appVersion";

export function usePushUserPropertiesToDataLayer<T extends Data>(
  key: userPropertiesScopeKeys,
  value: T
) {
  useEffect(() => {
    pushUserPropertiesToDataLayer({
      [key]: value
    });
  }, [key, value]);
}
